(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  if (window.__swishSystemFormEnhancersLoaded) {
    return;
  }
  window.__swishSystemFormEnhancersLoaded = true;

  var HOOP_PRODUCT_TEMPLATES = {
    'custom-wall-mouned-hoops': true,
    'cv54-product-page': true,
    'cv60-product-page': true,
    'cv72-product-page': true,
    'dc72-product-page': true,
    'fixedheight-product-page': true,
    'ft54-product-page': true,
    'ft60-product-page': true,
    'ft72-product-page': true,
    'gb50-product-page': true,
    'gb54-product-page': true,
    'gb60-product-page': true,
    'gotek50p-product-page': true,
    'gotek54ig-product-page': true,
    'gotek54p-product-page': true,
    'gotek54wall-product-page': true,
    'gs54c-product-page': true,
    'gs60c-product-page': true,
    'gs72c-product-page': true,
    'junior-product-page': true
  };

  var FLOORING_MARKERS = [
    'court-flooring',
    'sports-flooring',
    'court-builder',
    'court dimensions',
    'court-dimensions',
    'backyard-basketball-courts',
    'basketball-courts-for-schools-and-clubs',
    'basketball-courts-for-events',
    'swish-tiles',
    'swish-elite-court-tiles',
    'swish-large-elite-court-tiles',
    'swish-elastic-court-tiles',
    'all-sports-courts',
    'sports-courts',
    'outdoor-basketball-court-tiles',
    'design-your-sports-court',
    'design-swish-court-builder',
    'court preview',
    'court summary'
  ];
  var HOOP_MARKERS = [
    'basketball-hoops',
    'goalrilla',
    'goaliath',
    'backboard',
    'wall-mounted hoop',
    'in-ground hoop',
    'portable hoop'
  ];
  var XPT_MARKERS = ['xpt', 'xpt-trainer'];
  var VERSACLIMBER_MARKERS = ['versaclimber', 'versa-climber'];
  var GENERAL_MARKERS = ['/pages/about', 'about-us', '/pages/contact', 'contact-us'];
  var SUCCESS_MESSAGE = 'Thanks. We received your message. Our team member will contact you within 24 hours.';
  var ERROR_MESSAGE = 'We could not send your message right now. Please try again in a moment.';
  var MAXIMUM_CONTACT_UPLOAD_BYTES = 10 * 1024 * 1024;
  var MAXIMUM_CONTACT_UPLOAD_FILES = 5;
  var STOREIFY_FORM_PRESENTATION = {
    '11902': {
      title: 'Get Pricing',
      wrapperClass: 'swish-storeify-pricing-form--hardwood'
    }
  };

  function cleanString(value) {
    return value == null ? '' : String(value).trim();
  }

  function normalizeToken(value) {
    return cleanString(value)
      .toLowerCase()
      .replace(/[_\s]+/g, '-');
  }

  function getLocalization() {
    var localization = window.SWISH_SYSTEM_LOCALIZATION || {};
    return {
      market: cleanString(localization.market || localization.marketName),
      country: cleanString(localization.country || localization.countryCode),
      countryCode: cleanString(localization.countryCode)
    };
  }

  function getPageContext() {
    return window.SWISH_SYSTEM_PAGE_CONTEXT || {};
  }

  function getCurrentPageUrl() {
    return cleanString(getPageContext().pageUrl) || cleanString(window.location && window.location.href);
  }

  function getCurrentOrigin() {
    return cleanString(window.location && window.location.origin);
  }

  function getCanonicalProductUrl() {
    var pageContext = getPageContext();
    return cleanString(pageContext.productUrl) || getCurrentPageUrl();
  }

  function getProductTemplateFromContext(form) {
    var wrapper = form.closest('[data-swish-product-quote-wrapper]');
    if (wrapper) {
      var fromWrapper = cleanString(wrapper.getAttribute('data-swish-product-template'));
      if (fromWrapper) {
        return fromWrapper;
      }
    }

    return cleanString(getPageContext().productTemplate || getPageContext().templateSuffix);
  }

  function getProductTitleFromContext(form) {
    var wrapper = form.closest('[data-swish-product-quote-wrapper]');
    if (wrapper) {
      var fromWrapper = cleanString(wrapper.getAttribute('data-swish-product-title'));
      if (fromWrapper) {
        return fromWrapper;
      }
    }

    return cleanString(getPageContext().productTitle);
  }

  function getProductUrlFromContext(form) {
    var wrapper = form.closest('[data-swish-product-quote-wrapper]');
    if (wrapper) {
      var fromWrapper = cleanString(wrapper.getAttribute('data-swish-product-url'));
      if (fromWrapper) {
        return fromWrapper;
      }
    }

    return getCanonicalProductUrl();
  }

  function hasDimensionFields(form) {
    return Boolean(
      form.querySelector('[name="contact[Court Width]"], [name="contact[Your Court Width]"], [name="contact[Width]"]') ||
      form.querySelector('[name="contact[Court Length]"], [name="contact[Your Court Length]"], [name="contact[Length]"]')
    );
  }

  function textContainsAny(value, markers) {
    var normalized = cleanString(value).toLowerCase();
    if (!normalized) {
      return false;
    }

    return markers.some(function (marker) {
      return normalized.indexOf(marker) !== -1;
    });
  }

  function inferCategory(form) {
    var wrapper = form.closest('[data-swish-product-quote-wrapper]');
    var explicitCategory = cleanString(wrapper && wrapper.getAttribute('data-swish-product-category'));
    // A specific category is authoritative. GENERAL is only a fallback because
    // older migrated form wrappers can still carry that stale default.
    if (explicitCategory && explicitCategory !== 'GENERAL') {
      return explicitCategory;
    }

    var pageContext = getPageContext();
    var productTemplate = normalizeToken(getProductTemplateFromContext(form));
    var productText = [
      getProductTitleFromContext(form),
      getProductUrlFromContext(form),
      pageContext.productVendor
    ].join('\n');
    var pageUrl = getCurrentPageUrl();
    var searchablePageText = [pageUrl, getCanonicalProductUrl()].join('\n');

    if (productTemplate === 'xpt' || textContainsAny(productText + '\n' + searchablePageText, XPT_MARKERS)) {
      return 'XPT';
    }
    if (productTemplate === 'versaclimber' || textContainsAny(productText + '\n' + searchablePageText, VERSACLIMBER_MARKERS)) {
      return 'VERSACLIMBER';
    }
    if (productTemplate === 'swish-tiles' || hasDimensionFields(form) || textContainsAny(searchablePageText, FLOORING_MARKERS)) {
      return 'FLOORING';
    }
    if (HOOP_PRODUCT_TEMPLATES[productTemplate] || textContainsAny(productText + '\n' + searchablePageText, HOOP_MARKERS)) {
      return 'HOOPS';
    }
    if (textContainsAny(searchablePageText, GENERAL_MARKERS)) {
      return 'GENERAL';
    }

    return explicitCategory || 'GENERAL';
  }

  function getEcomposerFormType(form) {
    return inferCategory(form) === 'GENERAL' ? 'ecomposer-contact' : 'ecomposer-pricing';
  }

  function ensureHiddenInput(form, name, value, marker) {
    if (!form || !name) {
      return null;
    }

    var selector = marker
      ? 'input[type="hidden"][' + marker + '="true"]'
      : 'input[type="hidden"][name="' + name.replace(/"/g, '\\"') + '"]';
    var field = form.querySelector(selector);
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      if (marker) {
        field.setAttribute(marker, 'true');
      }
      form.appendChild(field);
    }

    field.value = cleanString(value);
    return field;
  }

  function setExistingFieldValue(form, selector, value) {
    if (!form || !selector) {
      return;
    }

    var field = form.querySelector(selector);
    if (!field) {
      return;
    }

    field.value = cleanString(value);
  }

  function syncStoreifyQuoteFields(form) {
    if (!form || !form.matches || !form.matches('form.storeify-form-action-quote')) {
      return;
    }

    var firstName = cleanString(form.querySelector('[name="storeifyInput_first_name"]') && form.querySelector('[name="storeifyInput_first_name"]').value);
    var lastName = cleanString(form.querySelector('[name="storeifyInput_last_name"]') && form.querySelector('[name="storeifyInput_last_name"]').value);
    var email = cleanString(form.querySelector('[name="storeifyInput_email"]') && form.querySelector('[name="storeifyInput_email"]').value);
    var notes = cleanString(form.querySelector('textarea[name^="storeifyInput_"]') && form.querySelector('textarea[name^="storeifyInput_"]').value);
    var productTitle = getProductTitleFromContext(form);
    var productUrl = getProductUrlFromContext(form);
    var pageUrl = getCurrentPageUrl();

    ensureHiddenInput(form, 'contact[First Name]', firstName, 'data-swish-storeify-first-name');
    ensureHiddenInput(form, 'contact[Last Name]', lastName, 'data-swish-storeify-last-name');
    ensureHiddenInput(form, 'contact[Email]', email, 'data-swish-storeify-email');
    ensureHiddenInput(form, 'contact[Notes]', notes, 'data-swish-storeify-notes');

    setExistingFieldValue(form, '[name="storeify_product_title"]', productTitle);
    setExistingFieldValue(form, '[name="storeify_product_href"]', productUrl);
    setExistingFieldValue(form, '[name="submit_from"]', pageUrl);
  }

  function primeFormMetadata(form) {
    var localization = getLocalization();
    var pageContext = getPageContext();
    var pageUrl = getCurrentPageUrl();
    var productTemplate = getProductTemplateFromContext(form);
    var productTitle = getProductTitleFromContext(form);
    var productUrl = getProductUrlFromContext(form);
    var category = inferCategory(form);

    syncStoreifyQuoteFields(form);

    ensureHiddenInput(form, 'contact[Source website]', getCurrentOrigin(), 'data-swish-source-website');
    ensureHiddenInput(form, 'contact[Source page]', pageUrl, 'data-swish-source-page');
    ensureHiddenInput(form, 'contact[Market]', localization.market, 'data-swish-market');
    ensureHiddenInput(form, 'contact[Country]', localization.country || localization.countryCode, 'data-swish-country');
    ensureHiddenInput(form, 'contact[Swish Category]', category, 'data-swish-category');

    if (productTemplate) {
      ensureHiddenInput(form, 'contact[Product Template]', productTemplate, 'data-swish-product-template');
    }
    if (productTitle || cleanString(pageContext.productTitle)) {
      ensureHiddenInput(form, 'contact[Product]', productTitle || cleanString(pageContext.productTitle), 'data-swish-product-title');
    }
    if (productUrl) {
      ensureHiddenInput(form, 'contact[Product Page]', productUrl, 'data-swish-product-page');
    }
  }

  function getSubmitButton(form) {
    return form.querySelector('button[type="submit"], input[type="submit"]');
  }

  function haltSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function getStatusBox(form) {
    var existing = form.querySelector('[data-swish-system-message], [data-contact-upload-message]');
    if (existing) {
      return existing;
    }

    existing = document.createElement('div');
    existing.className = 'form__message';
    existing.setAttribute('role', 'alert');
    existing.setAttribute('data-swish-system-message', 'true');
    existing.hidden = true;

    var submitButton = getSubmitButton(form);
    var action = submitButton && submitButton.closest('.ecom__form-action, .product-quote-form__actions');
    if (action && action.parentNode) {
      action.parentNode.insertBefore(existing, action);
    } else {
      form.appendChild(existing);
    }

    return existing;
  }

  function showStatusMessage(form, message, isError) {
    var box = getStatusBox(form);
    if (!box) {
      return;
    }

    box.textContent = message || '';
    box.hidden = !message;
    box.setAttribute('data-swish-system-status', isError ? 'error' : 'success');
  }

  function resolveContactUploadEndpoint(form) {
    var wrapper = form.closest('[data-swish-product-quote-wrapper]');
    var appUrl = cleanString(
      (wrapper && wrapper.getAttribute('data-swish-system-app-url')) ||
      window.SWISH_SYSTEM_PUBLIC_APP_URL
    );

    if (!appUrl) {
      return '';
    }

    try {
      return new URL('/api/public/intake/theme-contact/upload', appUrl).toString();
    } catch (error) {
      return appUrl.replace(/\/$/, '') + '/api/public/intake/theme-contact/upload';
    }
  }

  function clearContactUploadFields(form) {
    Array.prototype.slice.call(form.querySelectorAll('[data-swish-product-upload-url="true"]')).forEach(function (field) {
      field.remove();
    });
  }

  function appendContactUploadField(form, fileName, url) {
    var field = document.createElement('textarea');
    field.name = 'contact[Attachment files]';
    field.value = fileName + ': ' + url;
    field.hidden = true;
    field.setAttribute('data-contact-upload-hidden', 'true');
    field.setAttribute('data-swish-product-upload-url', 'true');
    form.appendChild(field);
  }

  async function uploadProductQuoteFiles(form, intake) {
    var input = form.querySelector('[data-swish-product-quote-file]');
    var files = input && input.files ? Array.prototype.slice.call(input.files) : [];
    if (!files.length) {
      return;
    }

    if (files.length > MAXIMUM_CONTACT_UPLOAD_FILES) {
      throw new Error('Please upload no more than ' + MAXIMUM_CONTACT_UPLOAD_FILES + ' files.');
    }

    files.forEach(function (file) {
      if (!file || file.size <= 0 || file.size > MAXIMUM_CONTACT_UPLOAD_BYTES) {
        throw new Error('Each attachment must be no larger than 10 MB.');
      }
    });

    var endpoint = resolveContactUploadEndpoint(form);
    if (!endpoint) {
      throw new Error('File uploads are not configured right now. Please try again later.');
    }

    var intakeId = typeof intake.ensureIntakeIdField === 'function'
      ? intake.ensureIntakeIdField(form)
      : '';
    var installationKey = cleanString(window.SWISH_MULTI_USE_INSTALLATION_KEY);
    var productTitle = getProductTitleFromContext(form);

    clearContactUploadFields(form);

    for (var index = 0; index < files.length; index += 1) {
      var file = files[index];
      var body = new FormData();
      body.append('file', file, file.name);
      body.append('intakeId', intakeId);
      body.append('product', productTitle);
      if (installationKey) {
        body.append('_installationKey', installationKey);
      }

      var response = await fetch(endpoint, {
        method: 'POST',
        body: body
      });
      var result = await response.json().catch(function () { return null; });
      if (!response.ok || !result || result.ok !== true || !result.url) {
        throw new Error(
          (result && (result.message || result.error)) ||
          'One of the attachments could not be uploaded. Please try again.'
        );
      }

      appendContactUploadField(form, cleanString(result.fileName) || file.name, result.url);
    }
  }

  async function submitToSwishSystem(form, options) {
    var intake = window.SwishSystemIntake;
    if (!intake || typeof intake.buildStandardFormPayload !== 'function' || typeof intake.postThemePayload !== 'function') {
      throw new Error('The inquiry endpoint is not available.');
    }

    await uploadProductQuoteFiles(form, intake);
    primeFormMetadata(form);

    var payload = intake.buildStandardFormPayload({
      form: form,
      section: form,
      source: options.source,
      formType: options.formType
    });

    var result = await intake.postThemePayload(form, payload);
    if (!result || !result.ok) {
      var message = result && (result.error || result.reason || (result.result && result.result.error));
      throw new Error(message || ERROR_MESSAGE);
    }

    return result;
  }

  function bindForm(form, options) {
    if (!form || form.dataset.swishSystemEnhancerBound === 'true') {
      return;
    }

    form.dataset.swishSystemEnhancerBound = 'true';
    primeFormMetadata(form);

    form.addEventListener('submit', async function (event) {
      if (form.dataset.swishSystemIntakeInFlight === 'true') {
        haltSubmit(event);
        return;
      }

      haltSubmit(event);
      form.dataset.swishSystemIntakeInFlight = 'true';
      showStatusMessage(form, '', false);

      var submitButton = getSubmitButton(form);
      if (submitButton) {
        submitButton.disabled = true;
      }

      try {
        await submitToSwishSystem(form, options);
        showStatusMessage(form, SUCCESS_MESSAGE, false);
      } catch (error) {
        showStatusMessage(form, (error && error.message) || ERROR_MESSAGE, true);
      } finally {
        form.dataset.swishSystemIntakeInFlight = 'false';
        if (submitButton) {
          submitButton.disabled = false;
        }
      }
    }, true);
  }

  function protectMigratedQuoteNotes(form) {
    var wrapper = form && form.closest && form.closest('[data-swish-product-quote-wrapper][data-swish-storeify-form-id]');
    var notes = form && form.querySelector && form.querySelector('textarea[name="contact[body]"]');
    if (!wrapper || !notes || notes.dataset.swishLegacySummaryGuard === 'true') {
      return;
    }

    notes.dataset.swishLegacySummaryGuard = 'true';
    var userEdited = false;
    var legacySummary = 'ship free samples to this address.: yes';

    notes.addEventListener('input', function (event) {
      if (event.isTrusted) {
        userEdited = true;
      }
    });

    function clearLegacySummary() {
      if (userEdited) {
        return;
      }

      var normalized = cleanString(notes.value).toLowerCase().replace(/\s+/g, ' ');
      if (normalized === legacySummary) {
        notes.value = '';
      }
    }

    clearLegacySummary();
    [0, 100, 500, 1000, 2500].forEach(function (delay) {
      setTimeout(clearLegacySummary, delay);
    });
  }

  function bindProductQuoteForms(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var forms = [];

    if (scope.matches && scope.matches('.product-quote-form-block form')) {
      forms.push(scope);
    }

    Array.prototype.slice.call(scope.querySelectorAll('.product-quote-form-block form')).forEach(function (form) {
      forms.push(form);
    });

    forms.forEach(function (form) {
      protectMigratedQuoteNotes(form);
      bindForm(form, {
        source: 'SHOPIFY_CONTACT',
        formType: 'product-quote'
      });
    });
  }

  function bindEcomposerForms(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var forms = [];

    if (scope.matches && scope.matches('form.ecom-contact-form')) {
      forms.push(scope);
    }

    Array.prototype.slice.call(scope.querySelectorAll('form.ecom-contact-form')).forEach(function (form) {
      forms.push(form);
    });

    forms.forEach(function (form) {
      bindForm(form, {
        source: 'SHOPIFY_CONTACT',
        formType: getEcomposerFormType(form)
      });
    });
  }

  function bindStoreifyQuoteForms(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var forms = [];

    if (scope.matches && scope.matches('form.storeify-form-action-quote')) {
      forms.push(scope);
    }

    Array.prototype.slice.call(scope.querySelectorAll('form.storeify-form-action-quote')).forEach(function (form) {
      forms.push(form);
    });

    forms.forEach(function (form) {
      if (form.closest('[data-swish-native-quote-suppressed="true"]')) {
        return;
      }

      var formIdInput = form.querySelector('input[name="storeify_form_id"]');
      var presentation = STOREIFY_FORM_PRESENTATION[cleanString(formIdInput && formIdInput.value)];

      if (presentation) {
        var wrapper = form.closest('.storeify-requestaquote');

        if (wrapper) {
          wrapper.classList.add(presentation.wrapperClass);

          if (normalizeToken(getProductTemplateFromContext(form)) === 'portable-hardwood-product') {
            wrapper.classList.add('swish-storeify-pricing-form--portable-hardwood');
          }

          var visibleTitle = wrapper.querySelector('.storeify-title-frm');
          var storedTitle = wrapper.querySelector('.title-frm-hide');

          if (visibleTitle) {
            visibleTitle.textContent = presentation.title;
          }
          if (storedTitle) {
            storedTitle.value = presentation.title;
          }
        }
      }

      bindForm(form, {
        source: 'SHOPIFY_CONTACT',
        formType: 'product-quote'
      });
    });
  }

  function suppressMigratedStoreifyForms() {
    Array.prototype.slice.call(
      document.querySelectorAll('[data-swish-product-quote-wrapper][data-swish-storeify-form-id]')
    ).forEach(function (wrapper) {
      var formId = cleanString(wrapper.getAttribute('data-swish-storeify-form-id'));
      var legacyWrapper = formId && document.getElementById('storeify_content_formbuilder_' + formId);
      if (!legacyWrapper) {
        return;
      }

      legacyWrapper.setAttribute('aria-hidden', 'true');
      legacyWrapper.setAttribute('data-swish-native-quote-suppressed', 'true');
      legacyWrapper.inert = true;
    });
  }

  function primeStandardContactForms(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var forms = [];

    if (
      scope &&
      scope.matches &&
      scope.matches('form') &&
      scope.closest &&
      scope.closest('[data-swish-system-form-type="shopify-contact"]')
    ) {
      forms.push(scope);
    }

    Array.prototype.slice.call(scope.querySelectorAll('[data-swish-system-form-type="shopify-contact"] form')).forEach(function (form) {
      forms.push(form);
    });

    forms.forEach(function (form) {
      primeFormMetadata(form);
    });
  }

  function init(root) {
    primeStandardContactForms(root);
    bindProductQuoteForms(root);
    bindEcomposerForms(root);
    suppressMigratedStoreifyForms();
    bindStoreifyQuoteForms(root);
  }

  window.SwishSystemFormEnhancers = Object.assign({}, window.SwishSystemFormEnhancers || {}, {
    inferCategory: inferCategory,
    primeFormMetadata: primeFormMetadata
  });

  function scheduleInit(root) {
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function () {
        init(root);
      });
      return;
    }

    setTimeout(function () {
      init(root);
    }, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    }, { once: true });
  } else {
    scheduleInit(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scheduleInit(event.target);
  });

  if (typeof MutationObserver === 'function') {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.slice.call(mutation.addedNodes || []).forEach(function (node) {
          if (!node || node.nodeType !== 1) {
            return;
          }
          scheduleInit(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
